import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function gearId(item, index) {
  const prefix = (item.categorySlug || item.category?.slug || 'EQP').slice(0, 3).toUpperCase();
  return `${prefix}-${String(index + 1).padStart(3, '0')}`;
}

function FeaturedGear({ items }) {
  const { t } = useTranslation();

  if (!items.length) {
    return null;
  }

  return (
    <section className="featured container" id="featured">
      <div className="section-label">
        <span>{t('sections.featured')}</span>
        <span>03 / 05</span>
      </div>
      <div className="gear-grid">
        {items.map((item, index) => (
          <div className="gear-card" key={item.documentId || item.id}>
            <span className="gear-id">{gearId(item, index)}</span>
            <div className="gear-name">{item.name}</div>
            <div className="gear-category">
              {item.categoryName || item.category?.name || t('catalog.equipmentFallback')}
            </div>
            {item.dailyRate != null && (
              <div className="gear-price">{t('catalog.plnPerDay', { rate: item.dailyRate })}</div>
            )}
            <div className="gear-status">
              <span className="dot-avail">{t('catalog.available')}</span>
              <a href="mailto:mikolaj.bonowski@gmail.com" className="reserve-link">
                {t('catalog.reserve')}
              </a>
            </div>
          </div>
        ))}
        <div className="gear-card gear-card--cta">
          <Link to="/#categories">{t('catalog.viewCatalog')}</Link>
        </div>
      </div>
    </section>
  );
}

export default FeaturedGear;
